module.exports = __webpack_public_path__ + "img/cmacgm.e381787a.jpeg";